import {getEnvVar} from "@delorean/utils/env-utils";

export enum CaptchaActionEnum {
  LOGIN = "login",
  RESET_PASSWORD = "password_reset",
}
const CAPTCHA_TIMEOUT_MS = 10000;
const CAPTCHA_SCRIPT_ID = "google-recaptcha-script";

export const loadCaptchaScript = (captchaKey: string): HTMLScriptElement => {
  const existing = document.getElementById(CAPTCHA_SCRIPT_ID) as HTMLScriptElement | null;
  if (existing) return existing;

  const captchaScript = document.createElement("script");
  captchaScript.id = CAPTCHA_SCRIPT_ID;
  captchaScript.src = `https://www.google.com/recaptcha/api.js?render=${captchaKey}`;
  captchaScript.async = true;
  captchaScript.onload = () => console.log('reCAPTCHA script loaded successfully');
  document.body.appendChild(captchaScript);
  return captchaScript;
};

// attende che window.grecaptcha sia disponibile, caricando lo script se assente
const waitForGrecaptcha = (captchaKey: string, timeoutMs: number) => {
  return new Promise<void>((resolve, reject) => {
    if (window.grecaptcha) {
      resolve();
      return;
    }

    const script = loadCaptchaScript(captchaKey);
    const start = Date.now();
    const intervalId = setInterval(() => {
      if (window.grecaptcha) {
        clearInterval(intervalId);
        resolve();
      } else if (Date.now() - start > timeoutMs) {
        clearInterval(intervalId);
        // rimuove lo script così un tentativo successivo può ricaricarlo
        script.remove();
        reject(new Error("reCAPTCHA non è disponibile"));
      }
    }, 100);
  });
};

export const useCaptcha = () => {
  const getCaptchaToken = async (action: CaptchaActionEnum) => {
    const captchaKey = getEnvVar('VITE_CAPTCHA_KEY');
    await waitForGrecaptcha(captchaKey, CAPTCHA_TIMEOUT_MS);

    return new Promise<string>((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error("reCAPTCHA timeout"));
      }, CAPTCHA_TIMEOUT_MS);

      window.grecaptcha.ready(() => {
        try {
          window.grecaptcha
            .execute(captchaKey, { action: action })
            .then((token: string) => {
              clearTimeout(timeoutId);
              resolve(token);
            })
            .catch((error: unknown) => {
              clearTimeout(timeoutId);
              console.error("reCAPTCHA execute error:", error);
              reject(new Error(`Error reCAPTCHA`));
            });
        } catch (error) {
          clearTimeout(timeoutId);
          console.error("reCAPTCHA execute error:", error);
          reject(new Error(`Error reCAPTCHA`));
        }
      });
    });
  };

  return { getCaptchaToken };
};
